import styles from "./TrainingSummary.module.css";
import { ZONE_DEFS, formatDuration } from "./zoneUtils";

export default function ZoneLegend({ zoneDurations }) {
  const total = Object.values(zoneDurations).reduce((a, b) => a + b, 0);
  return (
    <div className={styles.zonesSection}>
      <h3 className={styles.zonesTitle}>Heart Rate Zones</h3>
      {ZONE_DEFS.map(({ zone, name, color }) => {
        const duration = zoneDurations[zone] ?? 0;
        const pct = total > 0 ? (duration / total) * 100 : 0;
        return (
          <div key={zone} className={styles.zoneRow}>
            <span
              className={styles.zoneBar}
              style={{ width: `${pct}%`, backgroundColor: color }}
            />
            <span
              className={styles.zoneSquare}
              style={{ backgroundColor: color }}
            />
            <span className={styles.zoneNumber}>{zone}</span>
            <span className={styles.zoneName}>{name}</span>
            <span className={styles.zoneDuration}>
              {formatDuration(duration)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
